import { artistServices } from "../services";

export const fetchAllArtist = async (payload) => {
  try {
    const response = await artistServices.fetchArtists(payload);
    if (response.data.code === "OK") {
      return response.data.data;
    }
  } catch (error) {
    return error;
  }
};

export const fetchArtistById = async (id) => {
  try {
    const response = await artistServices.fetchArtistById(id);
    if (response.data.code === "OK") {
      return response.data.data;
    }
  } catch (error) {
    return error;
  }
};
